import { combineReducers } from "redux";
import ui from "./uiReducer";
import entities from "./entityReducer";

export default combineReducers({
  ui,
  entities
});
